export enum SupplyPointDetailTab {
  Overview = 'overview',
  Details = 'details',
  RenewableEnergy = 'renewable-energy',
  Hierarchy = 'hierarchy',
  Notifications = 'notifications',
  Files = 'files',
}
